import React, { useEffect } from 'react'
import WhatWeDo from './WhatWeDo';
import PerformanceAndStats from './PerformanceAndStats';
import CompanyTimeline from './CompanyTimeline';
import '../App.css'
import Slider from "react-slick";
import SEO from '../components/SEO';

const About = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const clients = [
    {
      name: "ToDo",
      logo: "../assets/lalogo.png", // replace with actual path
      url: "https://todolist-client-xi.vercel.app/",
    },
    {
      name: "E-Shop",
      logo: "/logos/businesso.png",
      url: "https://lashop10.vercel.app/",
    },
    {
      name: "Lasgram",
      logo: "/logos/webdigital.png",
      url: "https://lasgram.vercel.app/",
    },
    {
      name: "Chirps",
      logo: "/logos/ligroz.png",
      url: "https://laschirp.vercel.app/",
    },

  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    slidesToShow: 5,
    slidesToScroll: 1,
    pauseOnHover: false,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };


  return (
    <div>
      <SEO
        title="About | Lavanya Infotech"
        description="Learn more about Lavanya Infotech, our vision, values, and team."
      />
      
      <h1 className="title font-poppins text-4xl sm:text-5xl xl:pt-10 text-center font-bold">
        About Us
        <div className="aurora text-3xl">
          <div className="aurora__item"></div>
          <div className="aurora__item"></div>
          <div className="aurora__item"></div>
          <div className="aurora__item"></div>
        </div>
      </h1>

      <div className="text-slider pt-2 mt-10 text-center mb-10">
        <div className="animated-texts">
          <span className="animated-item text-blue-300 border-b-4 border-blue-300 text-2xl sm:text-3xl font-semibold">Inovation</span>
          <span className="animated-item text-green-300 border-b-4 border-green-300 text-2xl sm:text-3xl font-semibold">Exprertise</span>
          <span className="animated-item text-purple-300 border-b-4 border-purple-300 text-2xl sm:text-3xl font-semibold">Excellence</span>
          <span className="animated-item text-yellow-300 border-b-4 border-yellow-300 text-2xl sm:text-3xl font-semibold">Impact</span>
        </div>
      </div>

      <WhatWeDo />

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>

      <PerformanceAndStats />

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>

      <CompanyTimeline />

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>

      <div className="bg-black py-8 px-10 pd-10 pr-10 xyz1">
        <Slider {...settings}>
          {clients.map((client, index) => (
            <div key={index} className="flex justify-center items-center mx-1">
              <a href={client.url} target="_blank" rel="noopener noreferrer">
                <div className="rounded-full w-24 h-24 md:w-28 md:h-28 border-4 border-white shadow-lg bg-white flex items-center justify-center hover:scale-105 transition-transform">
                  <span className="text-black font-semibold text-sm md:text-base text-center px-2">
                    {client.name}
                  </span>
                </div>
              </a>
            </div>
          ))}
        </Slider>
      </div>

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>


    </div>
  )
}

export default About